module.exports = __webpack_public_path__ + "img/coupon-get-bg.f042825c.png";